import React, {createContext, useCallback, useContext, useEffect, useState} from 'react';
import server from '../global/server';
import {useApp} from '../context/AppContext';
import {useCookies} from 'react-cookie';

const AuthContext = createContext({});

export const AuthProvider = props => {
    const {setLoading} = useApp();
    const [cookies, setCookies, removeCokie] = useCookies(['token', 'user']);
    const [token, setToken] = useState();
    const [user, setUser] = useState();

    const globalParams = async () => {
        try {
            //FIXME: adicionar essa rota
            // const {data} = await server.get('/auth/publicRules');
            // const current_version = localStorage.getItem('current_version');
            // if( !Boolean(current_version) || current_version !== data.data.front_version){
            //     localStorage.setItem('current_version', data.data.front_version);
            //     window.location.reload()
            // }
        } catch (error) {
            console.log(error);
        }
    };

    const verifyAccount = async id => {
        // const {data} = await server.get('auth/user');
        // setCookies('user', data.data);
    };

    const verifySession = useCallback(async logout => {
        try {
            if (logout) throw 'Logout';
            setLoading(true);

            const token = cookies.token;
            const sessionUser = cookies.user;

            if (!Boolean(token) || !Boolean(sessionUser)) throw 'Not session';
            server.defaults.headers['Authorization'] = `Bearer ${token}`;
            await verifyAccount(sessionUser.id);
            setToken(token);
            setLoading(false);
        } catch (error) {
            console.log(error);
            delete server.defaults.headers.Authorization;
            setToken();
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        verifySession();
        globalParams();
    }, []);

    const Login = (user, token, path) => {
        server.defaults.headers['Authorization'] = `Bearer ${token}`;
        setCookies('user', user, {path: path || '/'});
        setCookies('token', token, {path: path || '/'});
        setToken(token);
    };

    const LogOut = () => {
        // setCookies('token', null)
        // setCookies('user', null)
        removeCokie('token');
        removeCokie('user');
        delete server.defaults.headers.Authorization;
        setToken();
        //verifySession(true);
        //navigate('/');
    };

    return (
        <AuthContext.Provider
            value={{
                logged: Boolean(token),
                user,
                LogOut,
                Login,
                verifySession,
                setUser,
                cookies,
                setCookies,
                removeCokie,
            }}>
            {props.children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => {
    const context = useContext(AuthContext);
    if (!context) throw 'Use Auth Context inside Auth Provider';

    return context;
};
